// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"35047027","509":"35047027","805":"35047027","826":"35047027"}[chunkId] + ".chunk.css";
};